import { render, staticRenderFns } from "./Investments.vue?vue&type=template&id=9cd3a174"
import script from "./Investments.vue?vue&type=script&lang=ts"
export * from "./Investments.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports